import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Table1 from "./Table1";
import Table2 from "./Table2";
import Table3 from "./Table3";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  genderList,
  userList,
  salutationList,
  errors,
  setselected_item_data,
  setselected_item_data_two,
  setselected_item_data_three,
  doctypeList,
  refetch,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];
  return (
    <div>
      <div className="px-3 py-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <p
                      className="m-0"
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Contact Details
                    </p>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={salutationList}
                      label="Salutation"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.solution}
                      onChange={(val) => handleChange("solution", val)}
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="Firstname"
                      label="Firstname"
                      style={{ height: "30px" }}
                      value={pageState.firstname}
                      onChange={(e) =>
                        handleChange("firstname", e.target.value)
                      }
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="lastname"
                      label="Lastname"
                      style={{
                        height: "30px",
                        ...(errors?.lastname
                          ? { border: "1px solid red" }
                          : {}),
                      }}
                      value={pageState.lastname}
                      onChange={(e) => handleChange("lastname", e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={genderList}
                      label="Gender"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.gender}
                      onChange={(val) => handleChange("gender", val)}
                      placeholder=""
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={userList}
                      label="User id"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.userid}
                      onChange={(val) => handleChange("userid", val)}
                      placeholder=""
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Input
                      id="Address"
                      label="Address"
                      style={{
                        height: "30px",
                        ...(errors?.address ? { border: "1px solid red" } : {}),
                      }}
                      value={pageState.address}
                      onChange={(e) => handleChange("address", e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#E3F5DF",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <p
                      className="m-0"
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      More Information
                    </p>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="Designation"
                      label="Designation"
                      style={{ height: "30px" }}
                      value={pageState.designation}
                      onChange={(e) =>
                        handleChange("designation", e.target.value)
                      }
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Input
                      id="Company Name"
                      label="Company Name"
                      style={{ height: "30px" }}
                      value={pageState.company_name}
                      onChange={(e) =>
                        handleChange("company_name", e.target.value)
                      }
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={statusList}
                      label="Status"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.status}
                      onChange={(val) => handleChange("status", val)}
                      placeholder=""
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ height: "19px" }}></label>
                    <Checkbox
                      id="Sync_with_Google_Contacts"
                      label="Sync with Google Contacts"
                      checked={pageState.is_google || false}
                      onChange={(checked) =>
                        onInputChange("is_google", checked)
                      }
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="Department"
                      label="Department"
                      style={{
                        height: "30px",
                        ...(errors?.department
                          ? { border: "1px solid red" }
                          : {}),
                      }}
                      value={pageState.department}
                      onChange={(e) =>
                        handleChange("department", e.target.value)
                      }
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <label style={{ height: "19px" }}></label>
                    <Checkbox
                      id="Unsubscribed"
                      label="Unsubscribed"
                      checked={pageState.unsubscribed || false}
                      onChange={(checked) =>
                        onInputChange("unsubscribed", checked)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div
            className="col-md-12 px-2"
            style={{ display: "flex", gap: "20px" }}
          >
            <div
              className=""
              style={{
                height: "100%",
                borderRadius: "4px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px",
                border: "1px solid #DBDBDB",
                borderRadius: "5px",
              }}
            >
              <div style={{ display: "flex", gap: "15px" }}>
                <div style={{ flex: 1 }}>
                  <p
                    className=""
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Email IDs
                  </p>
                </div>
              </div>

              <Table1 setselected_item_data={setselected_item_data} />
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div
            className="col-md-12 px-2"
            style={{ display: "flex", gap: "20px" }}
          >
            <div
              className=""
              style={{
                height: "100%",
                borderRadius: "4px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px",
                border: "1px solid #DBDBDB",
                borderRadius: "5px",
              }}
            >
              <div style={{ display: "flex", gap: "15px" }}>
                <div style={{ flex: 1 }}>
                  <p
                    className=""
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Phone Numbers
                  </p>
                </div>
              </div>

              <Table2 setselected_item_data_two={setselected_item_data_two} />
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div
            className="col-md-12 px-2"
            style={{ display: "flex", gap: "20px" }}
          >
            <div
              className=""
              style={{
                height: "100%",
                borderRadius: "4px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px",
                border: "1px solid #DBDBDB",
                borderRadius: "5px",
              }}
            >
              <div style={{ display: "flex", gap: "15px" }}>
                <div style={{ flex: 1 }}>
                  <p
                    className=""
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Reference
                  </p>
                </div>
              </div>

              <Table3
                setselected_item_data_three={setselected_item_data_three}
                pageState={pageState}
                onInputChange={onInputChange}
                doctypeList={doctypeList}
                refetch={refetch}
                list_data={list_data}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
